/*
 filtersEditor

 This component represents the filters editor.

 */

import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import {
    apiFiltersToUIFilters,
    ConditionGroupOperator,
    filterColumnSupportsListValues,
    updateFilterOperators
} from '../filters';

ko.components.register('report-filters-editor', {
    viewModel: reportFiltersEditor,
    template: {
        element: 'report-filters-editor-template'
    }
});

export function reportFiltersEditor(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof reportFiltersEditor)
        return data;

    self.loadingData = ko.observable(false);

    /******************
    DEFAULT FILTER OPERATOR
    *******************/
    self.defaultFilterOperator = "list";

    self.reportColumns = ko.observableArray([]);
    self.cols = ko.observableArray([]);
    self.reportFilters = ko.observableArray([]);
    self.getReportColumnsDataPromise = data.getReportColumnsDataPromise;
    self.getReportColumnsDataPromiseArgs = data.getReportColumnsDataPromiseArgs;
    self.getReportFiltersDataPromise = data.getReportFiltersDataPromise;
    self.getReportFiltersDataPromiseArgs = data.getReportFiltersDataPromiseArgs;
    self.getListOfValuesColumnsDataPromise = data.getListOfValuesColumnsDataPromise;
    self.onLoadFailedCallback = data.onLoadFailedCallback;
    self.validationMessage = ko.observable("");
    self.filterTypes = ko.observableArray([{ text: "And", value: "and" }, { text: "Or", value: "or" }]);
    self.deleteOnly = ko.observable(_.defaultIfNullOrUndefined(data.deleteOnly, false));
    self.editorSourceType = ko.observable(data.editorSourceType || "Report");

    //These are the column id's that support multiple filter values
    self.listValueColumns = ko.observableArray([]);

    self.filterIsEditable = function (filter) {
        return filter.sourceType() === self.editorSourceType();
    };

    self.openFilterSelectorButtonClick = function (item, event, filterIndex) {

        if (filterIndex < self.reportFilters().length) {
            var filter = self.reportFilters()[filterIndex];
            if (filterColumnSupportsListValues(filter, self.listValueColumns()))
                filter.showFilterSelector(true);
        }
    };

    self.closeFilterSelectorButtonClick = function (item, event, filterIndex) {

        if (filterIndex < self.reportFilters().length) {
            var filter = self.reportFilters()[filterIndex];
            filter.showFilterSelector(false);
        }
    };

    self.filterOperatorChanged = function (operator, dataItem, filterIndex) {

        if (filterIndex < self.reportFilters().length) {

            var filter = self.reportFilters()[filterIndex];
            var operator_old = filter.operator();
            filter.operator(operator);

            //Clear the listValues b/c they are no longer valid
            filter.listValues([]);
            filter.refreshValuesSelector();

            //If we are changing to/from a list of values, reset all the current values
            if (operator === "list" || operator_old === "list" || operator === "nlist" || operator_old === "nlist") {
                filter.value("");
            }

            //If list of values is not enabled, switch
            var listValuesEnabled = filterColumnSupportsListValues(filter, self.listValueColumns());
            if (!listValuesEnabled) {

                //The operator should not be "list"
                if (filter.operator() === "list") {
                    filter.operator("eq");
                }

                //The operator should not be "nlist"
                if (filter.operator() === "nlist") {
                    filter.operator("ne");
                }
            }

            //Show/hide the list of values filter selector
            filter.showFilterSelector(filter.operator() === "list" || filter.operator() === "nlist");

            filter.filterListValuesEnabled(listValuesEnabled && (filter.operator() === "list" || filter.operator() === "nlist"));
        }
    };

    self.filterColumnIdChanged = function (columnId, dataItem, filterIndex) {

        if (filterIndex < self.reportFilters().length) {

            var filter = self.reportFilters()[filterIndex];
            filter.column = _.find(self.reportColumns(), function (c) { return c.columnId() === columnId; });

            //Clear the listValues b/c they are no longer valid
            filter.listValues([]);
            filter.refreshValuesSelector();

            //If switching from a list of values, reset the value
            if (filter.filterListValuesEnabled()) {
                filter.value("");
            }

            //Set default operator
            filter.operator(self.defaultFilterOperator);

            //If list of values is not enabled, switch
            var listValuesEnabled = filterColumnSupportsListValues(filter, self.listValueColumns());
            if (!listValuesEnabled) {
                //Change the operator if it should not be list
                if (filter.operator() === "list")
                    filter.operator("eq");

                //Change the operator if it should not be nlist
                if (filter.operator() === "nlist")
                    filter.operator("ne");
            }

            //Show/hide the list of values filter selector
            filter.showFilterSelector(filter.operator() === "list" || filter.operator() === "nlist");

            filter.filterListValuesEnabled(listValuesEnabled && (filter.operator() === "list" || filter.operator() === "nlist"));
            updateFilterOperators(filter, self.listValueColumns());
        }
    };

    self.addFilterButtonClick = function () {

        if (self.deleteOnly())
            return;

        //Add properties to filters
        var filter = {};

        filter.columnId = ko.observable(-1);
        filter.column = undefined;
        filter.type = ko.observable("and");
        filter.operator = ko.observable(self.defaultFilterOperator);
        filter.showFilterSelector = ko.observable(false); //By default, do not show the filter selector on each filter
        filter.filterListValuesEnabled = ko.observable(false); //By default, the filter list values are not enabled
        filter.value = ko.observable("");
        filter.listValues = ko.observableArray([]);
        filter.filterOperators = ko.observableArray([]);
        filter.sourceType = ko.observable(self.editorSourceType());

        updateFilterOperators(filter, self.listValueColumns());

        if (!self.reportFilters()) {
            self.reportFilters([]);
        }

        self.reportFilters.push(filter);
    };

    self.removeFilterButtonClick = function (item, event) {
        self.reportFilters.remove(item);
    };

    self.getFilters = function () {
        var filters = ko.mapping.toJS(self.reportFilters() ?? []);
        return filters;
    };

    self.filtersAreValid = function () {

        var allColumnsAreSelected = true;
        var allValuesExist = true;

        _.forEach(self.reportFilters(), function (f) {
            if (f.columnId() < 0) {
                allColumnsAreSelected = false;
            }

            if (f.operator() === "list" || f.operator() === "nlist") {
                if (_.isNullOrUndefined(f.listValues()) || f.listValues().length === 0)
                    allValuesExist = false;
            }
            else {
                if (_.isNullOrUndefined(f.value()) || f.value() === "")
                    allValuesExist = false;
            }
        });

        var validationMessage = "";
        if (!allColumnsAreSelected)
            validationMessage = "All filters must have a selected column. ";

        if (!allValuesExist)
            validationMessage += "All filters must have a value.";

        self.validationMessage(validationMessage);

        return allColumnsAreSelected && allValuesExist;
    };

    var init = function () {

        //Call the promise functions to get columns and filters
        //if (_.isFunction(self.getReportFiltersDataPromise) && _.isFunction(self.getReportFiltersDataPromise().then)
        //  && _.isFunction(self.getReportColumnsDataPromise) && _.isFunction(self.getReportColumnsDataPromise().then)) {
        if (_.isFunction(self.getReportFiltersDataPromise) && _.isFunction(self.getReportColumnsDataPromise)) {

            //Spin the loader
            self.loadingData(true);

            var filterArgs = self.getReportFiltersDataPromiseArgs;
            var columnsArgs = self.getReportColumnsDataPromiseArgs;

            //Get the data
            $.when(
                self.getReportFiltersDataPromise.apply(null, filterArgs),
                self.getReportColumnsDataPromise.apply(null, columnsArgs),
                self.getListOfValuesColumnsDataPromise.apply(null)).then(
                    function (filters, columns, listOfValuesColumns) {
                        let allFilters = filters.direct;

                        const uneditableFilters = [filters.role, filters.user];

                        setGroupSourceType(filters.direct, 'Report');
                        setGroupSourceType(filters.role, 'Role');
                        setGroupSourceType(filters.user, 'User');

                        if (uneditableFilters.some(Boolean)) {
                            allFilters = {
                                conditions: [],
                                groups: [...uneditableFilters, filters.direct].filter(Boolean),
                                operator: ConditionGroupOperator.And
                            };
                        }

                        //Stop the loader
                        self.loadingData(false);

                        _.forEach(listOfValuesColumns, function (listCol) {
                            self.listValueColumns.push(listCol);
                        });

                        const reportFilters = allFilters
                            ? apiFiltersToUIFilters(allFilters, ConditionGroupOperator.And, columns, self.listValueColumns())
                            : null;

                        //Populate our arrays
                        self.reportFilters(reportFilters);
                        self.reportColumns(ko.mapping.fromJS(columns)());
                    },
                    function (xhr) {

                        //Stop the loader
                        self.loadingData(false);

                        if (_.isFunction(self.onLoadFailedCallback)) {
                            self.onLoadFailedCallback.apply(null, [xhr]);
                        }
                    }
                );
        }
    };

    init();
}

/**
 * Sets the source type for the conditions in the specified group.
 */
function setGroupSourceType(group, sourceType) {
    if (!group) {
        return;
    }

    const { conditions, groups } = group;

    for (const condition of conditions) {
        condition.sourceType = sourceType;
    }

    for (const group of groups) {
        setGroupSourceType(group, sourceType);
    }
}
